import {Controller} from "stimulus"
import $ from 'jquery';
import {validate_email} from "./validate_controller";


export default class extends Controller {
    connect() {
        let check_all = $('#check_all');
        let not_linked = $('.agency_not_linked');
        if (check_all.length > 0) {
            check_all.on('change', (e) => {
                if (not_linked.length > 0) {
                    not_linked.prop('checked', e.target.checked);
                }
            })
        }
    }

    link(e){
        let to_linked = $('.agency_not_linked:checked');
        let zoho_link = e.target.dataset.id;
        if(to_linked.length > 0){
            let id_to_linked = []
            to_linked.map((index, element) => {
                id_to_linked.push(element.dataset.id);
            })

            $.ajax({
                url: `${location.origin}/zoho/agencies/link`,
                data: {
                    zoho: zoho_link,
                    agencies: id_to_linked
                },
                type: 'POST',
                beforeSend: () => {
                    toastr.info('Enviando informacion para enlazar','Enviando datos')
                },
                success: (data) => {
                    if(data.success){
                        toastr.success(data.message, data.code)
                        setTimeout(()=>{
                            location.reload();
                        },500)
                    }else{
                        toastr.error(data.message, data.code)
                    }
                }
            })
        }else{
            toastr.warning('Debe seleccionar al menos un elemento del listado para continuar.','Atención')
        }
    }

}